import React,{useState,useEffect,}from 'react'
import { Table,Space, Form, Button, Select, Tag, Popover} from 'antd';
import { useIncomeExpenditureHxFinishListQuery,} from '../../store/ReactWebSiteApi';
import ArapEnterDel from './ArapEnterDel';
import Main from '../../cpn/Main'
import { useNavigate } from 'react-router-dom';
import {LogoutOutlined} from '@ant-design/icons';
import GetClient from '../client/GetClient';
import ArapCheckNum from './ArapCheckNum';
import FundCheck from '../fund/FundCheck';
function ArapList() {
    const [form] = Form.useForm();   
    const [query,setQuery] = useState({eie_e_id:localStorage.getItem('e_id'),bank_state:'',eie_client_id:''})
    const navi = useNavigate();      
    const {data,isSuccess} = useIncomeExpenditureHxFinishListQuery(query,{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eie_hx_number:key,eie_bank_log_id,eie_bank_ctime,eie_amount,eie_hx_content,ec_name,hx_num,eie_hx_amount,eie_hx_ctime,eie_hx_uname,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eg_name,eu_name,eie_bank_date,eie_audit1_ctime,eie_audit1_uname,eie_audit2_ctime,eie_audit3_ctime,eie_audit3_uname,eie_audit4_uname,eie_audit4_ctime,shehe_state} = item;
                    return item = {key,eie_bank_log_id,eie_bank_ctime,eie_amount,eie_hx_content,ec_name,hx_num,eie_hx_amount,eie_hx_ctime,eie_hx_uname,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eg_name,eu_name,eie_bank_date,eie_audit1_ctime,eie_audit1_uname,eie_audit2_ctime,eie_audit3_ctime,eie_audit3_uname,eie_audit4_uname,eie_audit4_ctime,shehe_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.eie_hx_ctime;
                    let bTimeString = b.eie_hx_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key',  
            render:(_,record) => {
                return <ArapCheckNum  eie_hx_number={record.key} type='数字'/>
            }          
        },         
        {
            key: 'client',
            title: '客户',
            dataIndex: 'ec_name',            
        },            
        {
            key: 'bishu',
            title: '下账数量',
            dataIndex: 'hx_num',
        },            
        {
            key: 'eie_hx_amount',
            title: '下账金额',
            dataIndex: 'eie_hx_amount',
        },                         
        {
            key: 'remark',
            title: '下账备注',
            dataIndex:'eie_hx_content',
        },            
        {
            key: 'num',
            title: '下账时间',
            dataIndex:'eie_hx_ctime',
            width:'16%',
            sorter: {
                compare: (a, b) => new Date(a.eie_hx_ctime).getTime() - new Date(b.eie_hx_ctime).getTime(),
            },
            render:(text,record) => {
                return<>
                    {text}{record.eie_hx_uname}
                </>
            }
        },                                               
        {
            key: 'shehe_state',
            title: '审核',
            dataIndex:'shehe_state',
            width:'6%',
            render:(text) => {
                if(text === 1){
                    return <Tag color='green'>已完成</Tag>
                }else{
                    return <Popover content={'收支至少有一条没有完成4级审核！'} title="什么是待完成？"><Tag color='magenta'>待完成</Tag></Popover>
                }
            }
        },                                                
        {
            key: 'eie_bank_ctime',
            title: '转账凭证',
            dataIndex:'eie_bank_ctime',
            render:(text,record) => {
                if(text){
                    return<>
                        {record.eie_bank_date}
                        <FundCheck ecal_id={record.eie_bank_log_id}/>
                    </>
                }else{
                    return<>待转账</>
                }
            }
        },                                               
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <Space>
                            <ArapCheckNum  eie_hx_number={record.key}/>
                            {!record.eie_bank_ctime && <ArapEnterDel eie_hx_number={record.key} />}
                          
                        </Space>
            }
        },
    ]

    return (
        <Main   t1='下账' n1='/ArapAddOld' t2='已下账列表' >
            <Space>
                <a 
                    style={{
                        fontSize:"18px"
                        }}
                    onClick={() => {
                        navi('/ArapAddOld')
                    }}
                ><LogoutOutlined /> 待下账列表</a>
                <Form
                    layout="inline"
                    onFinish={(e) => {
                        console.log(e);
                        setQuery(prevState=>({
                            ...prevState,
                            eie_client_id:e.eie_client_id?e.eie_client_id:'',
                            bank_state:e.bank_state?e.bank_state:''
                        }))
                    }}
                    form={form}
                    name="form_in_modal"
                    initialValues={{modifier: 'public',}}
                >
                    <GetClient
                        label='客户'
                        getClient={(e) => {}}  
                        name='eie_client_id'
                        style={{width:'140px'}}
                        setClient={true}
                        FormStyle={{marginBottom:"0",width:"180px"}}
                        labelCol={{span:6}}
                        initialValues={query.eie_client_id}
                    />
                    <Form.Item 
                        name='bank_state' 
                        label='类型' 
                        style={{width:"130px"}}
                        wrapperCol={{span:15}}
                        labelCol={{span:9}}
                    >                                    
                        <Select
                            value={query.bank_state}
                            style={{width:"100px"}}
                            options={[       
                                {
                                    value:"",
                                    label:'全部',
                                },
                                {
                                    value:"1",
                                    label:'已转账',
                                },
                                {
                                    value:"2",
                                    label:'待转账',
                                },        
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        style={{width:'65px'}}
                    >
                        <Button  
                            style={{marginLeft:"15px"}} 
                            htmlType='submit'
                        >查询</Button>   
                    </Form.Item>                                                          
                    <Form.Item style={{width:'65px'}}>
                        <Button onClick={() => { 
                            setQuery({eie_e_id:localStorage.getItem('e_id'),bank_state:'',eie_client_id:''})                                                             
                            form.resetFields();
                            }}>重置</Button>   
                    </Form.Item>    
                </Form>
            </Space>
            <Table 
                columns={columns}  
                style={{marginTop:'20px'}} 
                dataSource={list} 
                tableLayout='fixed'
                pagination={{
                    pageSize:50,
                    showSizeChanger:true,
                    showTotal:(total) => `共${total}条`,
                }} 
            />            
        </Main>
    )
    
}

export default ArapList